import './layout.scss';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCheckbox from '@ui-common/vue-checkbox';
import layoutBase from '../layout-base';

Vue.use(VueRouter);
Vue.component('vue-checkbox', VueCheckbox);
/* eslint-disable no-new*/
new Vue({
	extends: layoutBase,
	el: '[data-layout-id=AV9ES-app]'
});
/* eslint-enable*/
